import { Component, EventEmitter, Inject, Input, OnInit, Output, TemplateRef } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { SettingService } from 'src/app/applicationModules/settings/services/settingService/setting.service';
import { ReusableClasses } from 'src/app/middleware/common/reusableclassesAndFunctions/reusable-classes';
import { StatusConstant } from 'src/app/middleware/common/status/status-constant';
import { EncryptionService } from 'src/app/middleware/encryption/encryption.service';
import * as jwt_decode from 'jwt-decode';
import { LoaderService } from 'src/app/middleware/shared/loader/loader.service';
import { ToastrService } from 'ngx-toastr';
import { AddNtaDialogComponent } from './add-nta-dialog/add-nta-dialog.component';
import { ConfirmDialogComponent  ,ConfirmDialogModel} from 'src/app/middleware/common/reusableComponents/confirm-dialog/confirm-dialog.component';


//import { DataSharingService } from 'src/app/middleware/common/resuableServices/data-sharing.service';

// Interface for our data structure for better type safety
interface NtaSummary {
  ntaid:number;
  status: number | string;
  diagnosis: string;
  icD10: string;
  ntaCondition: string;
  clinicalCategory: string;
  ntaPoint: number;
  proposedICD10: string;
  potential: number;
  risk: string | null;
  isInclude: boolean;
  coreID:number;
  description:string;
  officeID:number;
  organizationID:number;

}

@Component({
  selector: 'app-nta',
  templateUrl: './nta.component.html',
  styleUrls: ['./nta.component.scss']
})


export class NTAComponent implements OnInit {
  organizationId: string;
  databaseId: string;
  currentUser: any;
  responseHolder: any;
  OfficeIDList: any = [];
  myOfficeID: any;
  ntaSummaryData: any = [] = [];
  summaryData: any = [] = [];
  currentNTA:any;
  @Input() transactionID: number=0; 
   processStageID: number=0;

   documentList:any=[]=[];

  // summaryData = [
  //   { title: 'NTA Points', value: 10 },
  //   { title: 'NTA CMG', value: 'NC' },
  //   { title: 'HIPPS Character', value: 'C' },
  //   { title: 'NTA CMI', value: '1.79' },
  //   { title: 'Step-Up Potential', value: '+3' },
  //   { title: 'Own-Coding Task', value: 'Low' },
  //   { title: 'Optimization Score', value: '85%' }
  // ];


  // ntaSummaryData = [
  //   {
  //     status: 'Definite',
  //     diagnosis: 'Acute Hypoxic Respiratory Failure',
  //     icd10: 'J96.02',
  //     ntaCondition: 'Cardio-Respiratory Failure & Shock',
  //     clinicalCategory: 'Respiratory Conditions',
  //     points: '1',
  //     proposed: '—',
  //     potential: '—',
  //     risk: 'Low',
  //     include: '-'
  //   },
  //   {
  //     status: 'Definite',
  //     diagnosis: 'COPD',
  //     icd10: 'J44.9',
  //     ntaCondition: 'Chronic Obstructive Pulmonary Disease',
  //     clinicalCategory: 'Respiratory Conditions',
  //     points: '2',
  //     proposed: '—',
  //     potential: '—',
  //     risk: 'Medium',
  //     include: '-'
  //   },
  //   {
  //     status: 'Definite',
  //     diagnosis: 'Diabetes Mellitus Type 2',
  //     icd10: 'E11.9',
  //     ntaCondition: 'Diabetes Mellitus',
  //     clinicalCategory: 'Endocrine Disorders',
  //     points: '3',
  //     proposed: '—',
  //     potential: '—',
  //     risk: 'High',
  //     include: '-'
  //   },
  //   {
  //     status: 'Definite',
  //     diagnosis: 'History of MRSA',
  //     icd10: 'Z86.14',
  //     ntaCondition: 'MRSA (Methicillin Resistant Staphylococcus Aureus)',
  //     clinicalCategory: 'Infectious Diseases',
  //     points: '1',
  //     proposed: '—',
  //     potential: '—',
  //     risk: 'High',
  //     include: '-'
  //   },
  //   {
  //     status: 'Definite',
  //     diagnosis: 'Malnutrition',
  //     icd10: 'E46',
  //     ntaCondition: 'Active Disease Malnutrition',
  //     clinicalCategory: 'Nutritional Disorders',
  //     points: '1',
  //     proposed: '—',
  //     potential: '—',
  //     risk: 'Low',
  //     include: '-'
  //   },
  //   {
  //     status: 'Review',
  //     diagnosis: 'Malnutrition',
  //     icd10: 'E46',
  //     ntaCondition: '—',
  //     clinicalCategory: 'Nutritional Disorders',
  //     points: '2',
  //     proposed: 'E43',
  //     potential: '+2',
  //     risk: 'Medium',
  //     include: '-'
  //   },
  //   {
  //     status: 'Review',
  //     diagnosis: 'Respiratory Failure',
  //     icd10: 'J96.02',
  //     ntaCondition: '—',
  //     clinicalCategory: 'Respiratory Conditions',
  //     points: '2',
  //     proposed: '296.61',
  //     potential: '+1',
  //     risk: 'High',
  //     include: '-'
  //   }
  // ];

  //clickEventsubscriptionPreviousNextCore: any;

  constructor(private taskService: SettingService,private dialog: MatDialog,
    private statusConst: StatusConstant, private encryptionAlgo: EncryptionService,
    private reusableClass: ReusableClasses, private loaderService: LoaderService,
    private toastr: ToastrService, 
    public dialogRef: MatDialogRef<NTAComponent>,
    private viewDialogRef: MatDialogRef<any>,
    //@Inject(MAT_DIALOG_DATA) public data: any 
  
  ) {
    const encryptedtoken = sessionStorage.getItem('userToken');
    this.databaseId = sessionStorage.getItem('databaseId')?? '';
     this.organizationId = sessionStorage.getItem('organizationID')?? '';
    const token = this.encryptionAlgo.get(this.reusableClass.encryptionKey, encryptedtoken);
    this.currentUser = jwt_decode(token);
    var offices = JSON.parse(sessionStorage.getItem('officeList'));
    offices.forEach(oe => {
      this.OfficeIDList.push(oe.officeID);
      if (oe.isMyoffice == true)
        this.myOfficeID = oe.officeID;
    });
  }

  private allNtaData: NtaSummary[] = [];
  public filteredNtaData: NtaSummary[] = [];
  public activeFilter: string = 'all';

  // --- Getters for Dynamic Filter Counts ---
  get allCount(): number {
    return this.allNtaData.length;
  }
  get readyCount(): number {
    return this.allNtaData.filter(item => item.status === 'Definite' && item.ntaPoint>0).length;
  }
  get stepUpCount(): number {
    return this.allNtaData.filter(item => item.status === 'Review').length;
  }
  get overCodingCount(): number {
    return this.allNtaData.filter(item => item.risk && item.risk.trim() !== '').length;
  }
  get allZeroCount(): number {
    return this.allNtaData.filter(item => (item.status === 'Definite' && item.ntaPoint === 0) || (item.status === 'Review' && item.potential===0)).length;
  }

 
  ngOnInit(): void {
    // this.clickEventsubscriptionPreviousNextCore = this._dataSharingService.getNextPreviousNTAFromCore().subscribe((result) => {
    //   if (result) {
    //    this.getAllNTASummaryList();
    //   }
    // });
    // if(this.data){

    // }
    var checktransactionId= sessionStorage.getItem('transationIdFromPDPM');
    if (checktransactionId){
      this.transactionID = Number(checktransactionId);
    }
    this.getAllNTASummaryList();
    this.GetMDSNTADocuments();
  }

  //  ngOnDestroy() {
  //   this.clickEventsubscriptionPreviousNextCore.unsubscribe();   
  // }
openAddNtaDialog(): void {
  const dialogRef = this.dialog.open(AddNtaDialogComponent, {
    width: '600px',
    data: { transactionID: this.transactionID }
  });

  dialogRef.afterClosed().subscribe(result => {
    if (result && result.action === 'save' && result.data) {
      this.saveNTAData(result.data);
    } else if (result === 'refresh') {
      this.getAllNTASummaryList();
    }
  });
}
editNta(item: any): void {
  const dialogRef = this.dialog.open(AddNtaDialogComponent, {
    width: '600px',
    data: { ntaItem: item, transactionID: this.transactionID }
  });

  dialogRef.afterClosed().subscribe(result => {
    if (result && result.action === 'save' && result.data) {
      // Replace with your save/update logic
      this.saveNTAData(result.data);
    }
  });
}

confirmDelete(item: any): void {
  const message = `Are you sure you want to delete this NTA?`;
  const title = `Confirm Delete`;
  const confirm = `Delete`;
  const dialogData = new ConfirmDialogModel(title, message, confirm);

  const dialogRef = this.dialog.open(ConfirmDialogComponent, {
    panelClass: 'edituserdetails',
    maxWidth: '1000px',
    maxHeight: '500px',
    data: dialogData
  });

  dialogRef.beforeClosed().subscribe(dialogResult => {
    if (dialogResult) {
      this.deleteNTA(item.ntaid);
    }
  });
}




private deleteNTA(ntaid: number) {
  const reqModel = {
    CoreID: Number(this.transactionID),
    NTAIDs: [ntaid],
    userID: this.currentUser.UID,
    organizationID: Number(this.organizationId),
    officeID: this.myOfficeID,
    databaseID: Number(this.databaseId)
  };

  this.loaderService.show();
  this.taskService.deleteNTASummary(reqModel).subscribe(response => {
    this.loaderService.hide();
    if (response && response.status === this.statusConst.statusSuccess && response.data) {
      // Remove deleted item from the list
      this.ntaSummaryData = this.ntaSummaryData.filter((x:any) => x.ntaid !== ntaid);
      this.toastr.success('NTA deleted successfully');
      this.getAllNTASummaryList();
    } else {
      this.toastr.error('Failed to delete NTA');
    }
  }, error => {
    this.loaderService.hide();
    this.toastr.error('Error occurred while deleting NTA');
    console.error(error);
  });
}



private saveNTAData(formData: any) {
  // Prepare the request model
const ReqModel = {
  ntaid: formData.ntaid || 0, // 0 for new
  coreID: Number(this.transactionID),
  userID: this.currentUser.UID,
  organizationID: Number(this.organizationId),
  officeID: this.myOfficeID,
  databaseID: Number(this.databaseId),
  ntaSummaryModel: {
    ntaid: formData.ntaid || 0,
    diagnosis: formData.diagnosis,
    icD10: formData.icD10,
    ntaCondition: formData.ntaCondition,
    description: formData.description || null,
    clinicalCategory: formData.clinicalCategory,
    ntaPoint: formData.ntaPoint || 0,
    proposedICD10: formData.icD10 || null,
    potential: formData.potential || 0,
    risk: formData.risk || null,
    isInclude: formData.isInclude ?? true,
    status: formData.status,
    coreID: Number(this.transactionID),
    officeID: this.myOfficeID,
    organizationID: Number(this.organizationId)
  }
};

  this.loaderService.show();
  this.taskService.addUpdateNTASummary(ReqModel).subscribe(response => {
    this.loaderService.hide();
    if (response && response.status === this.statusConst.statusSuccess && response.data) {
      this.toastr.success('NTA saved successfully!');
      this.getAllNTASummaryList(); // refresh the grid
    } else {
      this.toastr.error(response?.message || 'Failed to save NTA.');
    }
  }, err => {
    this.loaderService.hide();
    this.toastr.error('Something went wrong while saving NTA.');
  });
}


   public setFilter(filter: string): void {
    this.activeFilter = filter;
    switch (filter) {
      case 'ready':
        this.filteredNtaData = this.allNtaData.filter(item => item.status === 'Definite' && item.ntaPoint >0 );
        break;
      case 'stepUp':
        this.filteredNtaData = this.allNtaData.filter(item => item.status === 'Review');
        break;
      case 'overCoding':
        this.filteredNtaData = this.allNtaData.filter(item => item.risk && item.risk.trim() !== '');
        break;
      case 'allZero':
        this.filteredNtaData = this.allNtaData.filter(item => (item.status === 'Definite' && item.ntaPoint === 0) || (item.status === 'Review' && item.potential===0));
        break;
      case 'all':
      default:
        this.filteredNtaData = [...this.allNtaData].sort((a, b) => {
          const getPriority = (item: any): number => {
            if (item.status === 'Definite' && item.ntaPoint > 0) return 1;
            if (item.status === 'Review' && item.potential > 0) return 2;
            if (item.status === 'Definite' && item.ntaPoint === 0) return 3;
            if (item.status === 'Review' && item.potential === 0) return 4;
            return 5; // Other items
          };
          
          return getPriority(a) - getPriority(b);
        });
        break;
    }
  }


  getAllNTASummaryList() {
    const ReqModel = {
      coreID: Number(this.transactionID),
      userID: this.currentUser.UID,
      organizationID: Number(this.organizationId),
      databaseID: Number(this.databaseId),
      officeID: this.myOfficeID,
    };
    this.loaderService.show();
    this.taskService.getAllNTASummaryList(ReqModel).subscribe((response) => {
      this.loaderService.hide();
      if (response && response.status === this.statusConst.statusSuccess) {
        if (response.data) {
          this.responseHolder = response;
          this.ntaSummaryData = response.data.ntaSummaries;
          if (this.ntaSummaryData && this.ntaSummaryData.length > 0) {
            this.ntaSummaryData.forEach(item => {
              item.statusId = item.status;
              if (item.status === 0) {
                item.status = 'Unknown';
              
              } else if (item.status === 1) {
                item.status = 'Definite';
              } else if (item.status === 2) {
                item.status = 'Review';
              } else {
                item.status = 'Unknown'; // fallback
              }
            });
          }
           this.allNtaData=this.ntaSummaryData;
           this.setFilter('all'); // Set initial filter

          const summary = response.data.summary;

          if (summary) {
            this.summaryData = [
              { title: 'NTA Points', value: summary.ntaPoints ?? 'NA' },
              { title: 'NTA CMG', value: summary.ntaCmg ?? 'NA' },
              { title: 'HIPPS Character', value: summary.hippsCharacter ?? 'NA' },
              { title: 'NTA CMI', value: summary.ntaCmi ?? 'NA' },
              { title: 'Step-Up Potential', value: summary.stepUpPotential ?? 'NA' },
              { title: 'Over-Coding Risk', value: summary.overCodingRisk ?? 'NA' },
              { title: 'Optimization Score', value: summary.optimizationScore != null ? summary.optimizationScore + '%' : '0%' }
            ];
          } else {
            this.summaryData = [
              { title: 'NTA Points', value: 'NA' },
              { title: 'NTA CMG', value: 'NA' },
              { title: 'HIPPS Character', value: 'NA' },
              { title: 'NTA CMI', value: 'NA' },
              { title: 'Step-Up Potential', value: 'NA' },
              { title: 'Over-Coding Risk', value: 'NA' },
              { title: 'Optimization Score', value: '0%' }
            ];
          }
        } else {
          this.ntaSummaryData = [];
          this.summaryData = [];
          this.loaderService.hide();
        }
      } else {
        this.loaderService.hide();
        this.ntaSummaryData = [];
        this.summaryData = [];
      }
    });
  }

  onCheckboxChange(e:any, item:any){
     const originalItem = this.allNtaData.find(d => d.ntaid == item.ntaid);
    if (originalItem) {
        originalItem.isInclude = e.checked;
    }
    // Re-apply the current filter to reflect changes immediately
    this.setFilter(this.activeFilter);
    const ntaSummaryPointCopy = { ...item };
    const ReqModel = {
      coreID: Number(this.transactionID),
      userID: this.currentUser.UID,
      organizationID: Number(this.organizationId),
      databaseID: Number(this.databaseId),
      officeID: this.myOfficeID,
      IsAdd:e.checked,
      NTASummaryPoint:ntaSummaryPointCopy 
    };
    if(ReqModel.NTASummaryPoint.status=="Review") {
      ReqModel.NTASummaryPoint.status=2;
    }else{
      ReqModel.NTASummaryPoint.status=1;
    }
    this.loaderService.show();
    this.taskService.CalculateAndReassignNtaValues(ReqModel).subscribe((response) => {
      this.loaderService.hide();
      if (response && response.status === this.statusConst.statusSuccess) {
        if (response.data) {
          this.responseHolder = response;
          this.ntaSummaryData = response.data.ntaSummaries;
          if (this.ntaSummaryData && this.ntaSummaryData.length > 0) {
            this.ntaSummaryData.forEach(item => {
              if (item.status === 0) {
                item.status = 'Unknown';
              } else if (item.status === 1) {
                item.status = 'Definite';
              } else if (item.status === 2) {
                item.status = 'Review';
              } else {
                item.status = 'Unknown'; // fallback
              }
            });
          }

           this.allNtaData=this.ntaSummaryData;
           this.setFilter(this.activeFilter); // Set initial filter

          const summary = response.data.summary;

          if (summary) {
            this.summaryData = [
              { title: 'NTA Points', value: summary.ntaPoints ?? 'NA' },
              { title: 'NTA CMG', value: summary.ntaCmg ?? 'NA' },
              { title: 'HIPPS Character', value: summary.hippsCharacter ?? 'NA' },
              { title: 'NTA CMI', value: summary.ntaCmi ?? 'NA' },
              { title: 'Step-Up Potential', value: summary.stepUpPotential ?? 'NA' },
              { title: 'Over-Coding Risk', value: summary.overCodingRisk ?? 'NA' },
              { title: 'Optimization Score', value: summary.optimizationScore != null ? summary.optimizationScore + '%' : '0%' }
            ];
          } else {
            this.summaryData = [
              { title: 'NTA Points', value: 'NA' },
              { title: 'NTA CMG', value: 'NA' },
              { title: 'HIPPS Character', value: 'NA' },
              { title: 'NTA CMI', value: 'NA' },
              { title: 'Step-Up Potential', value: 'NA' },
              { title: 'Over-Coding Risk', value: 'NA' },
              { title: 'Optimization Score', value: '0%' }
            ];
          }
        } else {
          this.ntaSummaryData = [];
          this.summaryData = [];
          this.loaderService.hide();
        }
      } else {
        this.loaderService.hide();
        this.ntaSummaryData = [];
        this.summaryData = [];
      }
    });
  }

  close() {
    if (this.viewDialogRef) {
      this.viewDialogRef.close();
    }
  }

 viewNTADetails(templateRef: TemplateRef<any>, nta:any) {
  this.currentNTA=nta;

    
    // Open new dialog and store reference
    this.viewDialogRef = this.dialog.open(templateRef);
    
    // Automatically clear reference when dialog closes
    this.viewDialogRef.afterClosed().subscribe(() => {
      this.viewDialogRef = null;
    });
  }

GetMDSNTADocuments() {
  const ReqModel = {
    coreID: Number(this.transactionID),
    processStageID: this.processStageID,
    userID: this.currentUser.UID,
    organizationID: Number(this.organizationId),
    databaseID: Number(this.databaseId),
    officeID: this.myOfficeID,
  };
  this.taskService.getMDSNTADocuments(ReqModel).subscribe({
    next: (response) => {
      if (response) {
        this.documentList = response;
      } else {
        this.documentList = [];
      }
    },
    error: (err) => {
      //console.error("Error fetching documents:", err);
      this.documentList = [];
    }
  });
 }

  @Output() documentViewers = new EventEmitter<boolean>();
  documentPath: string = "";
  fileType: string = "pdf";
  documentname: string = "";
  isRendering: boolean = false;
  private documentDialogRef: MatDialogRef<any> | null = null;

  openDocument(templateRef: TemplateRef<any>,url) {
   this.documentPath = url;   
   this.documentViewers.emit(true);
   //this.dialog.open(templateRef);
   this.documentDialogRef = this.dialog.open(templateRef);
  }

   getCloseDocumentViewer(_message: boolean) {
    this.documentViewers.emit(false);
    //this.dialog.closeAll();
    // Close only this document's dialog
     if (this.documentDialogRef) {
      this.documentDialogRef.close();
      this.documentDialogRef = null; // cleanup
     }
  }

   closeDialog() {
   this.dialogRef.close();
  }

}
